var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { staticClass: "ops-page", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("任务设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "opsForm",
              staticClass: "ops-form",
              attrs: { model: _vm.form },
            },
            [
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("签到任务设置")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("任务签到积分"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb16",
                      attrs: { data: _vm.signinDays, border: "", size: "mini" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "label",
                          label: "签到天数",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(7, function (d) {
                        return _c("el-table-column", {
                          key: d,
                          attrs: { label: "第" + d + "天", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: {
                                        min: 0,
                                        max: 99999,
                                        "controls-position": "right",
                                        size: "mini",
                                      },
                                      model: {
                                        value:
                                          _vm.signinDays[scope.$index].days[
                                            d - 1
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.signinDays[scope.$index].days,
                                            d - 1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "signinDays[scope.$index].days[d - 1]",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub-title" }, [
                    _vm._v("\n          签到奖励\n          "),
                    _c("span", { staticClass: "reward-count" }, [
                      _vm._v("（共" + _vm._s(_vm.form.rewards.length) + "项）"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    _vm._l(_vm.form.rewards, function (reward, index) {
                      return _c("el-col", { key: index, attrs: { span: 8 } }, [
                        _c(
                          "div",
                          { staticClass: "reward-card" },
                          [
                            _c(
                              "div",
                              { staticClass: "reward-header" },
                              [
                                _c("div", { staticClass: "reward-title" }, [
                                  _vm._v("连续签到" + _vm._s(index + 1) + "天"),
                                ]),
                                _vm._v(" "),
                                _c("el-button", {
                                  staticClass: "delete-btn",
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close",
                                    disabled: _vm.form.rewards.length <= 1,
                                    title: "删除此奖励项",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeReward(index)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "奖励类型",
                                  "label-width": "80px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "积分",
                                      size: "mini",
                                    },
                                    model: {
                                      value: reward.type,
                                      callback: function ($$v) {
                                        _vm.$set(reward, "type", $$v)
                                      },
                                      expression: "reward.type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "积分", value: "score" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "优惠券",
                                        value: "coupon",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "签到奖励",
                                  "label-width": "80px",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    size: "mini",
                                  },
                                  model: {
                                    value: reward.value,
                                    callback: function ($$v) {
                                      _vm.$set(reward, "value", $$v)
                                    },
                                    expression: "reward.value",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "奖励文案",
                                  "label-width": "80px",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    size: "mini",
                                  },
                                  model: {
                                    value: reward.desc,
                                    callback: function ($$v) {
                                      _vm.$set(reward, "desc", $$v)
                                    },
                                    expression: "reward.desc",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-rank", on: { click: _vm.addReward } },
                    [
                      _c("i", { staticClass: "el-icon-circle-plus" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("添加签到奖励")]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("签到视觉与跳转配置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签到背景图" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "background-uploader",
                          attrs: {
                            action: "#",
                            "list-type": "picture-card",
                            limit: 1,
                            "auto-upload": false,
                            "on-exceed": _vm.onExceed,
                            "file-list": _vm.form.backgroundImages,
                            "on-preview": _vm.handlePictureCardPreview,
                            "on-remove": _vm.handleRemove,
                            "on-change": _vm.handleBackgroundChange,
                            "before-upload": _vm.beforeUpload,
                            accept: "image/*",
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                "\n              只能上传jpg/png文件，且不超过2MB\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dialog",
                        {
                          attrs: { visible: _vm.dialogVisible, size: "tiny" },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogVisible = $event
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.dialogImageUrl,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签到 banner" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "banner-uploader",
                          attrs: {
                            action: "#",
                            "list-type": "picture-card",
                            limit: 1,
                            "auto-upload": false,
                            "on-exceed": _vm.onExceed,
                            "file-list": _vm.form.bannerImages,
                            "on-preview": _vm.handlePictureCardPreview,
                            "on-remove": _vm.handleRemove,
                            "on-change": _vm.handleBannerChange,
                            "before-upload": _vm.beforeUpload,
                            accept: "image/*",
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                "\n              只能上传jpg/png文件，且不超过2MB\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "banner跳转分类" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "160px" },
                          attrs: { placeholder: "系统链接", size: "mini" },
                          model: {
                            value: _vm.form.banner.linkType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.banner, "linkType", $$v)
                            },
                            expression: "form.banner.linkType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "系统链接", value: "system" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "自定义链接", value: "custom" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "160px", "margin-left": "8px" },
                          attrs: { placeholder: "券广场", size: "mini" },
                          model: {
                            value: _vm.form.banner.target,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.banner, "target", $$v)
                            },
                            expression: "form.banner.target",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "券广场", value: "couponSquare" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "任务中心", value: "taskCenter" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("任务规则/任务配置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "签到日常：奖励" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.signinReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "signinReward", $$v)
                          },
                          expression: "form.rules.signinReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("积分")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务*关注公众号：奖励积分" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.followReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "followReward", $$v)
                          },
                          expression: "form.rules.followReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("积分")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务*添加我的小程序：奖励积分" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.addMiniReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "addMiniReward", $$v)
                          },
                          expression: "form.rules.addMiniReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("积分")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务*点赞：奖励" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.likeReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "likeReward", $$v)
                          },
                          expression: "form.rules.likeReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [
                        _vm._v("积分 每日最多"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "ml8",
                        attrs: { min: 0, max: 999, size: "mini" },
                        model: {
                          value: _vm.form.rules.likeMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "likeMax", $$v)
                          },
                          expression: "form.rules.likeMax",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("次")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务*评论：奖励" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.commentReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "commentReward", $$v)
                          },
                          expression: "form.rules.commentReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [
                        _vm._v("积分 每日最多"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "ml8",
                        attrs: { min: 0, max: 999, size: "mini" },
                        model: {
                          value: _vm.form.rules.commentMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "commentMax", $$v)
                          },
                          expression: "form.rules.commentMax",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("次")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务*分享：奖励" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.rules.shareReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "shareReward", $$v)
                          },
                          expression: "form.rules.shareReward",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [
                        _vm._v("积分 每日最多"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "ml8",
                        attrs: { min: 0, max: 999, size: "mini" },
                        model: {
                          value: _vm.form.rules.shareMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.rules, "shareMax", $$v)
                          },
                          expression: "form.rules.shareMax",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("次")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务规则" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder: "1、签到奖励周期为7天...",
                        },
                        model: {
                          value: _vm.form.rulesText,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "rulesText", $$v)
                          },
                          expression: "form.rulesText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ops-block", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "block-title",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_vm._v("积分扣减")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "删除上贴" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.deduction.deletePost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.deduction, "deletePost", $$v)
                          },
                          expression: "form.deduction.deletePost",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("积分")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "取消审核贴" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, size: "mini" },
                        model: {
                          value: _vm.form.deduction.cancelReview,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.deduction, "cancelReview", $$v)
                          },
                          expression: "form.deduction.cancelReview",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml8" }, [_vm._v("积分")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ops-actions" },
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }